import { useState, useCallback } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import NavigationDropdown from "../../components/NavigationDropdown";
import NavigationPanel from "../../components/NavigationPanel";
import PortalPopup from "../../components/PortalPopup";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import LPDConfirmation from "../../components/LPDConfirmation";
import LPDAutoPopulate from "../../components/LPDAutoPopulate";
import Breadcrumb from "../../components/Breadcrumb";
import Footer from "../../components/Footer";
import { getCurrentUser } from "../../utils/getCurrentUser";

const LPDPage_2 = () => {
  const navigate = useNavigate();
  const [isNavigationDropdownOpen, setNavigationDropdownOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isLPDConfirmationOpen, setLPDConfirmationOpen] = useState(false);
  const user = getCurrentUser();

  const openNavigationDropdown = useCallback(() => {
    setNavigationDropdownOpen(true);
  }, []);

  const closeNavigationDropdown = useCallback(() => {
    setNavigationDropdownOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openLPDConfirmation = useCallback(() => {
    setLPDConfirmationOpen(true);
  }, []);

  const closeLPDConfirmation = useCallback(() => {
    setLPDConfirmationOpen(false);
  }, []);

  const breadcrumb = [
    { label: "Late Payment Demand (LPD)", path: "/lpd", active: false },
    { label: "New LPD", path: "", active: true },
  ];

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen flex flex-col overflow-visible text-left text-sm text-neutrals-neutral-300 font-open-sans-ff-body-strong">
        {/* Navigation Panel */}
        <NavigationPanel />

        {/* Main Content */}

        <div className="w-full absolute top-[136px] flex flex-col flex-grow px-4 md:px-4 lg:px-24 gap-6 box-border">
          {/* Breadcrumb */}
          <Breadcrumb breadcrumbs={breadcrumb} />
          <div className="w-full flex flex-col items-start justify-start gap-6">
            <div className="self-stretch flex flex-col items-start justify-start gap-6 text-lg text-neutrals-neutral-900">
              {/* Heading */}
              <div className="self-stretch border-neutrals-neutral-100 border-solid border-b-[1px] flex flex-row items-start justify-start pt-0 px-0 pb-6">
                <div className="relative font-semibold">Debtor's details</div>
              </div>

              {/* LPD Auto Populate */}
              <div className="self-stretch mb-40">
                <LPDAutoPopulate userId={user?.id} />
              </div>
            </div>
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>

      {/* Popups */}
      {isNavigationDropdownOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeNavigationDropdown}
        >
          <NavigationDropdown onClose={closeNavigationDropdown} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isLPDConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLPDConfirmation}
        >
          <LPDConfirmation onClose={closeLPDConfirmation} />
        </PortalPopup>
      )}
    </>
  );
};

export default LPDPage_2;
